define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var LocalizationHelper = require('web-agent-utils/LocalizationHelper');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var ChatLineStateViewController = require('web-agent-viewControllers/ChatLineStateViewController');
    var ChatLineImageViewController = require('web-agent-viewControllers/chatLineImageViewController');
    var ChatLineAudioViewController = require('web-agent-viewControllers/ChatLineAudioViewController');
    var BotEscalationBubbleViewController = require('web-agent-viewControllers/BotEscalationBubbleViewController');
    var StructuredContentBubbleViewController = require('web-agent-viewControllers/StructuredContentBubbleViewController');
    var QuickRepliesBubbleViewController = require('web-agent-viewControllers/QuickRepliesBubbleViewController');
    var SecureFormChatBubbleViewController = require('web-agent-viewControllers/SecureFormChatBubbleViewController');
    var SchemaValidator = require('web-agent-utils/SchemaValidator');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');


    var ChatViewController = ViewController.extend({
        ControllerName: "ChatViewController",

        LPViewMap: {
            chatState: ".lpview_chat_view_state",
            agentSummary: ".lpview_agent_summary",
            chatLinesArea: ".lpview_chat_lines_area",
            endTimeText: ".lpview_end_text",
            chatEndTime: ".lpview_chat_end_time",
            chatDurationText: ".lpview_chat_duration_text",
            chatDuration: ".lpview_chat_duration",
            linesAreaInBubble: ".lpview_lines_placeholder_in_bubble",
            visitorNewMessages: ".lpview_visitor_new_messages",
            visitorState: ".lpview_visitor_state_current",
            visitorTypingState: ".lpview_visitor_typing_state",
            sentimentMessage: ".lpview_sentiment_message",
            sentimentCloseButton: ".lpview_sentiment_close_button",
            scrollPositionStartPoint: ".lpview_scroll_position_start_point",
            engagementArea: ".lpview_engagement_area"
        },

        LPClassesMap: {
            singleChatLineSeparator: "chat_single_line_separator",
            typingImage: "typing_image",
            private: "private",
            hide: "hide"
        },
        separatorTypes: {
            simple: "simple",
            date: "date",
            dialogStart: "dialogStart",
            dialogEnd: "dialogEnd"
        },
//        idnvAnswerIndicationRegex: /data-lp-collab-type\s*=\s*["|']idnv_answer["|']/,

        initialize: function (constructorData) {
            this.singleton = constructorData.singleton;
            this.chatId = constructorData.chatId;
            this.visitorId = constructorData.visitorId;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.bindToChatModel = typeof constructorData.bindToChatModel !== "undefined" ? constructorData.bindToChatModel : true;
            this.agentName = this.getModelParam('agent.agentName');
            this.isFocused = false;
            this.supprtScrollToBottom = true;
            this.scrollToBottomWhenFocused = false;
            this.supportNewMessagesCount = true;
            this.newMessages = 0;
            this.chatLineIds = {};
            this.firstRow = true;
            this.note = constructorData.note;
            this.asyncMessaging = constructorData.asyncMessaging;
            this.isHistory = constructorData.isHistory;
            this.chatLineStates = [];
            if (typeof this.asyncMessaging === 'undefined' || this.asyncMessaging === null) {
                this.asyncMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId, this.chatsRootModelPath);
            }
            var appEventsChannel = webAgentStatics.COMMUNICATION_CHANNELS.AppEvents;
            lpTag.WebAgent.channel.bind(appEventsChannel.name, appEventsChannel.events.queryMessagesCompleted, this.refreshViewOnQueryMessage.bind(this));
        },
        events: function () {
            if (this.visitorId) {
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
                this.bindModel({modelPath: participantPath + '.participantTag', callback: this.participantTagChanged});
                if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
                    this.bindModel({
                        modelPath: participantPath + '.participantInfo.sentimentScore',
                        callback: this.updateEngagementSentiment
                    });
                }
            }
            this.bindModel({modelPath: "agent.agentName", callback: this.updateAgentName});
            this.bindViewEvent({
                selector: this.LPViewMap.chatLinesArea,
                DOMEvent: "scroll",
                callback: this.saveScrollingPosition
            }); // TODO handle this differently when in singleton
            this.bindViewEvent({selector: window, DOMEvent: "resize", callback: this.scrollToBottomIfNeeded});
            this.bindViewEvent({
                selector: this.LPViewMap.visitorNewMessages,
                DOMEvent: "click",
                callback: this.scrollToBottom
            });
            this.bindViewEvent({
                selector: this.LPViewMap.sentimentCloseButton,
                DOMEvent: "click",
                callback: this.hideSentimentMessage
            });
            this.viewEventsHandler.bindEvent({
                appName: this.visitorId,
                UIEvent: this.eventType.VISITOR_FOCUSED,
                callback: this.visitorFocused
            });
            this.viewEventsHandler.bindEvent({
                appName: this.visitorId,
                UIEvent: this.eventType.VISITOR_BLURRED,
                callback: this.visitorBlurred
            });

            if (this.chatId && this.bindToChatModel) {
                this.bindChatModel(this.chatId);
                this.bindChatEvent(this.chatId);
            }

            if (lpTag.WebAgent.logicController.hasCoBrowseFeature() ||
                lpTag.WebAgent.logicController.hasLiveVideoFeature() ||
                lpTag.WebAgent.logicController.hasLiveVoiceFeature()) {
                /*
                 *  separate this from the chat view class, and add a listener to be attached when we interact with the co-browse (when the service is created.)
                 * */
                agentLEManager.onLEEvent("lpCoBrowseController:Notification", this.onCoBrowseNotification, this);
            }

        },
        render: function () {
        }
    });

    window.ChatViewController = ChatViewController;


    ChatViewController.prototype.updateAgentSummary = function (summaryText) {
        this.removeAgentSummaryView(this.summaryView);
        this.summaryView = this.createAgentSummaryView(summaryText);
    };

    ChatViewController.prototype.createAgentSummaryView = function (summaryText) {
        var summaryViewOptions;
        if (_.isString(summaryText) && !_.isEmpty(summaryText)) {
            summaryViewOptions = {
                templateFile: 'LP_history_item_agent_summary.html',
                target: this.getFirstElement(this.LPViewMap.agentSummary),
                textInjection: {
                    summaryContent: summaryText
                }
            };
            return this.createView(summaryViewOptions);
        }
    };

    ChatViewController.prototype.removeAgentSummaryView = function (summaryView) {
        if (summaryView) {
            this.removeView({view: summaryView});
        }
    };

    ChatViewController.prototype.onCoBrowseNotification = function (message) {

        if (message && message.data && message.data.visitorId && message.data.visitorId == this.visitorId) {
            var translationKey, systemLine, interaction = "COBROWSE";
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(message.data.visitorId);
            var visitorName = this.getModelParam(participantPath + ".participantInfo.visitorName");

            if (message.data.mode === "VIDEO_CALL" || message.data.mode === "VOICE_CALL") {
                interaction = "CALL";
            }

            switch (message.data.type) {
                case 'event':
                    switch (message.data.name) {
                        case 'visitorAccept':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_ACCEPTED';
                            systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            break;

                        case 'visitorDecline':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_DECLINE';
                            systemLine = this.isTranslated(translationKey) ? this.translateObj(translationKey, [{key: visitorName}]) : "";
                            break;

                        case 'sessionEnded':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_SESSION_END';
                            systemLine = this.isTranslated(translationKey) ? this.translateObj(translationKey, [{key: visitorName}]) : "";
                            break;

                        case 'visitorJoined':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_JOINED_SESSION';
                            systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            break;

                        case 'visitorLeft':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_LEFT_SESSION';
                            systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            break;

                        case 'revokeOffer':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_OFFER_REVOKED';
                            systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            break;

                        case 'pendingOffer':
                            translationKey = interaction + '_NOTIFICATION_MESSAGE_VISITOR_PENDING_OFFER';
                            systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            break;

                        case 'error':
                            if (message.data.data && message.data.data.id) {
                                switch (message.data.data.id) {
                                    case 'offerTimedOut':
                                        translationKey = interaction + '_NOTIFICATION_MESSAGE_ERROR_OFFER_TIMED_OUT';
                                        systemLine = this.isTranslated(translationKey) ? this.translateObj(translationKey, [{key: visitorName}]) : "";
                                        break;
                                    case 'serviceUnavailable':
                                        translationKey = interaction + '_NOTIFICATION_MESSAGE_ERROR_SERVICE_UNAVAILABLE';
                                        systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                                        break;
                                    case 'visitorNotJoinedSession':
                                        translationKey = interaction + '_NOTIFICATION_MESSAGE_ERROR_VISITOR_NOT_JOINED_SESSION';
                                        systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                                        break;
                                    case 'requestPending':
                                        translationKey = interaction + '_NOTIFICATION_MESSAGE_ERROR_PENDING_REQUEST';
                                        systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                                        break;
                                    case 'activeSessionInProgress':
                                        translationKey = interaction + '_NOTIFICATION_MESSAGE_ERROR_ACTIVE_SESSION';
                                        systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                                        break;
                                }
                            }
                            else {
                                // Generic Error.
                                translationKey = interaction + '_NOTIFICATION_MESSAGE_GENERIC_ERROR';
                                systemLine = this.isTranslated(translationKey) ? this.translate(translationKey) : "";
                            }
                            break;
                    }
                    break;
            }
            if (systemLine) {
                this.addFakeSystemLine(systemLine);
            }
        }
    };

    ChatViewController.prototype.updateMsgState = function (state, sequenceList) {
        if (this.asyncMessaging) {
            var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId);

            // reader participants are not allowed to set message state, message state will be updated when a manager joins the conversation
            if (activeDialogId && !lpTag.WebAgent.logicController.isLoggedInAgentReaderParticipant(this.chatId, activeDialogId)) {
                this.modelController.setMsgStatus({
                    conversationId: this.chatId,
                    dialogId: activeDialogId,
                    state: state || lpTag.AMSStatics.messageState.READ,
                    sequenceList: sequenceList
                });
            }
        }
    };

    ChatViewController.prototype.visitorTypingState = function (data) {
        // Handle visitor state, if none defined use a custom one, otherwise use what the the user defined.
        if (typeof data.newValue !== 'undefined') {
            var translatedText = this.asyncMessaging ? this.translate('consumerTyping') : this.translate('participantTyping');
            var visitorStateView = this.getFirstElement(this.LPViewMap.visitorState);
            if (visitorStateView) {
                this.setVisitorTypingState(visitorStateView, data.newValue, translatedText);
            } else {
                this.logger.error("Failed to set the visitor typing state, could not find appropriate view", "visitorTypingState");
            }
            visitorStateView = null;
        }
    };

    ChatViewController.prototype.setVisitorTypingState = function (visitorStateView, state, translatedText) {
        if (state) {
            visitorStateView.innerHTML = translatedText;
            visitorStateView.removeAttribute('tooltip-hide');
            visitorStateView.setAttribute('title', translatedText);
            this.addClass(visitorStateView, this.LPClassesMap.typingImage);
        } else {
            visitorStateView.innerHTML = '';
            visitorStateView.setAttribute('tooltip-hide', '');
            this.removeClass(visitorStateView, this.LPClassesMap.typingImage);
        }
    };

    ChatViewController.prototype.visitorNewMessagesState = function () {
        if (this.scrolledToBottom) {
            this.newMessages = 0;
        }
        var visitorNewMessagesView = this.getFirstElement(this.LPViewMap.visitorNewMessages);
        if (visitorNewMessagesView) {
            if (this.newMessages > 0) {
                visitorNewMessagesView.innerHTML = this.newMessages > 1 ? this.translateObj('participantNewMessages', [this.newMessages]) : this.translate('participantSingleNewMessage');
            } else {
                visitorNewMessagesView.innerHTML = '';
            }
        }
        visitorNewMessagesView = null;
    };

    ChatViewController.prototype.visitorFocused = function () {
        if (!this.isFocused) {
            this.isFocused = true;
            if (this.scrollToBottomWhenFocused) {
                this.scrollToBottom();
                this.scrollToBottomWhenFocused = false;
            } else {
                this.resumeScrollingPosition();
            }
        }

        if (this.asyncMessaging) {
            this.updateMsgState();
        }
    };

    ChatViewController.prototype.visitorBlurred = function () {
        if (this.isFocused) {
            this.isFocused = false;
        }
    };

    ChatViewController.prototype.updateScroll = function () {
        if (this.scrolledToBottom) {
            this.scrollToBottom();
        } else {
            this.resumeScrollingPosition();
        }
    };

    ChatViewController.prototype.chatStates = {
        active: "active_engagement_chat_view",
        inactive: "passive_engagement_chat_view"
    };

    ChatViewController.prototype.lineSubTypes = {
        NON_RESPONSIVE: "NON_RESPONSIVE",
        STALLER: "STALLER",
        REGULAR: "REGULAR",
        ONLY_TO_REP: "ONLY_TO_REP",
        SECURE_FORM: "leSecureForm",
        RICH_CONTENT: "richContent"
    };

    ChatViewController.prototype.lineTypes = {
        PARTICIPANT: {
            user: "visitor",
            templateFile: "LP_chat_bubble_visitor.html",
            textPlaceholder: ".lpview_single_line_bubble_text",
            timePlaceholder: ".lpview_visitor_bubble_time",
            namePlaceholder: ".lpview_visitor_bubble_name"
        },
        AGENT: {
            user: "agent",
            templateFile: "LP_chat_bubble_agent.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_agent_bubble_name",
            timePlaceholder: ".lpview_agent_bubble_time",
            bubble: ".lpview_agent_bubble",
            style: {opacity: 0.5}
        },
        AGENT_PRIVATE: {
            user: "agentPrivate",
            templateFile: "LP_chat_bubble_agent.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_agent_bubble_name",
            timePlaceholder: ".lpview_agent_bubble_time",
            bubble: ".lpview_agent_bubble",
            style: {opacity: 0.5}
        },
        AGENT_AUTOMATED: {
            user: "agentAutomated",
            templateFile: "LP_chat_bubble_agent_automated.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_agent_bubble_name",
            timePlaceholder: ".lpview_agent_bubble_time",
            bubble: ".lpview_agent_bubble"
        },
        AGENT_CENSORED: {
            user: "agentCensured",
            templateFile: "LP_chat_bubble_agent_censured.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_agent_bubble_name",
            timePlaceholder: ".lpview_agent_bubble_time",
            bubble: ".lpview_agent_bubble"
        },
        ANOTHER_AGENT: {
            user: "agent2",
            templateFile: "LP_chat_bubble_other_agent.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_other_agent_bubble_name",
            timePlaceholder: ".lpview_other_agent_bubble_time"
        },
        ANOTHER_AGENT_PRIVATE: {
            user: "agent2private",
            templateFile: "LP_chat_bubble_other_agent_private.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_other_agent_bubble_name",
            timePlaceholder: ".lpview_other_agent_bubble_time"
        },
        ANOTHER_AGENT_AUTOMATED: {
            user: "agent2automated",
            templateFile: "LP_chat_bubble_other_agent_automated.html",
            textPlaceholder: ".lpview_lines_placeholder_in_bubble",
            namePlaceholder: ".lpview_other_agent_bubble_name",
            timePlaceholder: ".lpview_other_agent_bubble_time"
        },
        INFO: {
            user: "system",
            templateFile: "LP_chat_bubble_status.html",
            textPlaceholder: ".lpview_status_bubble_text",
            timePlaceholder: ".lpview_status_bubble_time"
        }
    };

    ChatViewController.prototype.participantTagChanged = function (data) {
        if (this.view && this.view.firstChild && data.newValue) {
            if (this.participantTag) {
                this.removeClass(this.view.firstChild, this.participantTag);
            }
            this.participantTag = data.newValue;
            this.addClass(this.view.firstChild, data.newValue);
        }
    };

    ChatViewController.prototype.updateChatId = function (chatId) {
        this.updateScroll();
        if (this.chatId === chatId) {//if we're updating the chatId to the same chatId we don't want to loss its chatLineIds
            return;
        }

        this.refreshView(chatId);
    };

    ChatViewController.prototype.refreshViewOnQueryMessage = function(chatId) {
        if (chatId === this.chatId) {
            this.refreshView(chatId);
        }
    };

    ChatViewController.prototype.refreshView = function(chatId){
        addCurrentChatLines(this);

        this.resetChatView(this.asyncMessaging);
        this.addSplitSessionSeparatorIfNeeded();

        this.unbindChatModel(this.chatId);
        this.unbindChatEvent(this.chatId);
        this.chatId = chatId;
        this.bindChatEvent(this.chatId);
        this.bindChatModel(this.chatId);


        function addCurrentChatLines(context) {
            var key = context.chatsRootModelPath + context.chatId + '.newChatLine.lines';
            var chatLines = context.getModelParam(key);
            context.handleChatLines({newValue: chatLines, key: key});
        }
    };

    ChatViewController.prototype.resetChatView = function (force) {
        this.setChatByState();
        if (this.singleton || force) {
            this.chatLineIds = {};
            this.getFirstElement(this.LPViewMap.chatLinesArea).innerHTML = "";
            this.previousBubbleSource = "";
            this.previousDate = null;
            this.previousDialogId = null;
            this.disposeChatLineStates();
        }
    };

    ChatViewController.prototype.addSplitSessionSeparatorIfNeeded = function () {
        if (!this.singleton && this.visitorId && !this.asyncMessaging) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            var visitorName = this.getModelParam(participantPath + ".participantInfo.visitorName");
            this.createView({
                templateFile: "LP_chat_bubble_split_session.html",
                target: this.getFirstElement(this.LPViewMap.chatLinesArea),
                textInjection: {visitorName: visitorName}
            });
        }
    };

    ChatViewController.prototype.setOfflineChatView = function (chatId, supportTextHighLight) {
        if (this.chatId === chatId) {//if we're updating the chatId to the same chatId we don't want to loss its chatLineIds
            return;
        }
        this.chatId = chatId;
        this.supportTextHighLight = supportTextHighLight;
        this.resetChatView();
        this.supportNewMessagesCount = false;
        this.supprtScrollToBottom = false;
        var chatLines = this.getModelParam(this.chatsRootModelPath + chatId + '.chatInfo.events');
        this.handleChatLines({newValue: chatLines});
    };

    ChatViewController.prototype.unbindChatModel = function (chatId) {
        if (this.singleton) {  //This chat is on spectate mode
            this.unbindModel({
                modelPath: this.chatsRootModelPath + chatId + '.chatInfo.events',
                callback: this.handleChatLines
            });
        } else {
            this.unbindModel({
                modelPath: this.chatsRootModelPath + chatId + '.oldChatLine.lines',
                callback: this.handleOldChatLines
            });
            this.unbindModel({
                modelPath: this.chatsRootModelPath + chatId + '.newChatLine.lines',
                callback: this.handleChatLines
            });
        }
        this.unbindModel({
            modelPath: this.chatsRootModelPath + chatId + '.visitorInfo.visitorTyping',
            callback: this.visitorTypingState
        });
        this.unbindModel({
            modelPath: this.chatsRootModelPath + chatId + '.chatInfo.state',
            callback: this.setChatByState
        });
        if (this.asyncMessaging) {
            if (lpTag.WebAgent.logicController.agentCanViewChat(this.getModelParam(this.chatsRootModelPath + chatId + '.chatInfo')) && lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(chatId)) {
                this.unbindModel({
                    modelPath: this.chatsRootModelPath + chatId + '.chatInfo.allParticipantsHash',
                    callback: this.onParticipationChanged,
                    context: this
                });
            }
            this.unbindModel({
                modelPath: this.chatsRootModelPath + chatId + '.chatInfo.activeDialogId',
                callback: this.onActiveDialogIdChanged,
                context: this
            });
        }
    };

    ChatViewController.prototype.bindChatModel = function (chatId) {
        this.scrolledToBottom = true;
        if (this.singleton) {  //This chat is on spectate mode
            this.bindModel({
                modelPath: this.chatsRootModelPath + chatId + '.chatInfo.events',
                callback: this.handleChatLines
            });
        } else {
            // Not ignoring the current agent lines when binding, since those are the first transcript lines
            // After transfer, this agent might have some there,
            // Afterward, ignoring the current agent lines since we add them manually.
            this.ignoreCurrentAgentLines = false;

            this.bindModel({
                modelPath: this.chatsRootModelPath + chatId + '.oldChatLine.lines',
                callback: this.handleOldChatLines
            });
            this.bindModel({
                modelPath: this.chatsRootModelPath + chatId + '.newChatLine.lines',
                callback: this.handleChatLines
            });
        }
        this.bindModel({
            modelPath: this.chatsRootModelPath + chatId + '.visitorInfo.visitorTyping',
            callback: this.visitorTypingState
        });
        this.bindModel({
            modelPath: this.chatsRootModelPath + chatId + '.chatInfo.state',
            callback: this.setChatByState
        });
        if (this.asyncMessaging) {
            if (lpTag.WebAgent.logicController.agentCanViewChat(this.getModelParam(this.chatsRootModelPath + chatId + '.chatInfo')) && lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(chatId)) {
                this.bindModel({
                    modelPath: this.chatsRootModelPath + chatId + '.chatInfo.allParticipantsHash',
                    callback: this.onParticipationChanged,
                    context: this
                });
            }
            this.bindModel({
                modelPath: this.chatsRootModelPath + chatId + '.chatInfo.activeDialogId',
                callback: this.onActiveDialogIdChanged,
                context: this
            });
        }
    };

    ChatViewController.prototype.bindChatEvent = function (chatId) {
        this.viewEventsHandler.bindEvent({
            appName: chatId,
            UIEvent: this.eventType.CONTENT_ADDED_TO_CONVERSATION,
            callback: this.scrollToBottomIfNeeded
        });
    };

    ChatViewController.prototype.unbindChatEvent = function (chatId) {
        this.viewEventsHandler.unbindEvent({
            appName: chatId,
            UIEvent: this.eventType.CONTENT_ADDED_TO_CONVERSATION,
            callback: this.scrollToBottomIfNeeded
        });
    };

    ChatViewController.prototype.onActiveDialogIdChanged = function (data) {
        if (data.removedValue && this.dialogsWithLines && this.dialogsWithLines[data.removedValue]) { // add end dialog separator line when dialog closed on live (from notification) and dialog had lines
            var chatViewFragment = document.createDocumentFragment();
            var separatorData = {
                separatorOnly: true,
                time: new Date(),
                lastLineOfDialog: true,
                conversationId: this.chatId,
                dialogId: data.removedValue
            };
            this.addLineElement(chatViewFragment, separatorData);
            this.addView({
                targetView: this.getFirstElement(this.LPViewMap.chatLinesArea),
                viewToAdd: chatViewFragment
            });
        }
    };

    ChatViewController.prototype.onParticipationChanged = function () {
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath);
        if (!activeDialogId) {
            return;
        }
        var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(this.chatId, activeDialogId, this.chatsRootModelPath);
        var canUpdateStateMsg = (role === lpTag.WebAgent.logicController.participantsRoles.MANAGER);
        if (canUpdateStateMsg && !this.singleton) {
            this.updateMsgState();
        }
    };

    ChatViewController.prototype.addFakeSystemLine = function (message) {

        // creating the fake line:
        var fakeLine = {
            '@type': 'line',
            textType: 'plain',
            by: 'info',
            source: 'system',
            subType: 'ONLY_TO_REP',
            time: (new Date()).toISOString(),
            text: message
        };

        this.handleChatLines({newValue: [fakeLine]});
    };

    ChatViewController.prototype.handleOldChatLines = function (data) {
        if (!this.asyncMessaging) {
            return;
        }
        if (!data || !data.newValue) {
            return;
        }
        var chatMsgs = {};
        var chatLines;

        if (isTtriggerFromOldChatLines(data.key)) {
            chatLines = this.getModelParam('chats.' + this.chatId + '.newChatLine.lines') || [];
            chatMsgs.newValue = data.newValue.concat(chatLines);
        } else {
            chatLines = this.getModelParam('chats.' + this.chatId + '.chatInfo.events.event') || [];
            chatMsgs.newValue = data.newValue.event.concat(chatLines);
        }
        this.handleChatLines(chatMsgs, true);


        function isTtriggerFromOldChatLines(key) {
            var arr = key.split('.');
            if (arr.indexOf('oldChatLine') !== -1) {
                return true;
            }
            return false;
        }


    };

    ChatViewController.prototype.updateUploadState = function(data) {
        var verificationId = (data && data.newValue && data.newValue.appName) || null;
        data = (data && data.newValue && data.newValue.eventData) || data || {};
        var lineView = this.getFirstElement("#" + verificationId);
        this.removeClass(lineView, 'file_loading');
        this.removeClass(lineView, 'file_retry');
        this.removeClass(lineView, 'file_error');
        if (data.showLoader) {
            this.addClass(lineView, 'file_loading');
        } else if(data.error) {
            if (!data.canRetry) {
                this.addClass(lineView, 'file_error');
            } else {
                this.addClass(lineView, 'file_retry');
            }
        }
    };


    /**
     * Updating new chat lines into the dom,
     * When receiving a line with verification ID (already populated by us) we just update its opacity.
     *
     * Using a fragment document to speed up the lines adding to the DOM, specially when refreshing the page, and the chat has many lines.
     * @param data
     * @param oldChatLines
     */
    ChatViewController.prototype.handleChatLines = function (data, oldChatLines) {
        if (!data || typeof data.newValue === 'undefined' || data.newValue === null) {
            return;
        }
        var chatLines = data.newValue.event ? data.newValue.event : data.newValue;
        var chatId = (data && data.key ) ? data.key.split(".")[1] : this.chatId;
        if (!chatLines || chatLines.length === 0) {
            return;
        }
        // When adding the old chat lines we re-render all the chat lines (old & new) so we want to reset the view first
        if (oldChatLines) {
            this.resetChatView(this.asyncMessaging);
            this.ignoreCurrentAgentLines = false;
            this.scrolledToBottom = true;
        }

        var chatViewFragment = document.createDocumentFragment(); // this fragment will be populated with the bubbles UI and then will be injected to the DOM

        if (this.supportTextHighLight) {
            setTextHighlightValues(this);
        }
        if (this.isFocused) {
            this.updateMsgState();
        }
        if (this.asyncMessaging) {
            chatLines[0].first = true;
        }
        for (var i = 0; i < chatLines.length; i++) {
            var chatLine = chatLines[i];
            var type = getLineType(chatLine); // chatLine.type || chatLine['@type'];
            renderChatLineByTypes(this, type);
            renderChatLineByMetadada(this);
        }

        this.ignoreCurrentAgentLines = true;

        this.addView({
            targetView: this.getFirstElement(this.LPViewMap.chatLinesArea),
            viewToAdd: chatViewFragment
        });

        this.scrollToBottomIfNeeded();
        this.visitorNewMessagesState();

        this.scrollToSpecificLine(this, this.LPViewMap.scrollPositionStartPoint);

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////// help methods ////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        function renderChatLineByTypes(context, type) {
            switch (type) {
                case 'line':
                    renderChatLine();
                    break;
                case 'leCollaboration':
                    renderLeCollaborationLine();
                    break;
                case 'richContent':
                    renderRichContentLine();
                    break;
            }

            function renderChatLine() {
                if (lineAlreadyExists(context, chatLine)) {
                    if (chatLine.verificationId) {
                        updateLineVerificationStatus(context, chatLine);
                    }
                } else {
                    var templateInfo = getLineTemplate(context, chatLine);
                    if (templateInfo && chatLine.text !== "" || context.isImageLine(chatLine)) {
                        context.addLineElement(chatViewFragment, chatLine, templateInfo);
                        if (templateInfo === context.lineTypes.AGENT || templateInfo === context.lineTypes.AGENT_PRIVATE) {
                            context.scrolledToBottom = true;
                        }
                    }
                    if (!oldChatLines) {
                        updateNewMessagesCount(context, chatLine);
                    }
                }
            }

            function renderRichContentLine() {
                if (lineAlreadyExists(context, chatLine)) {
                    if (chatLine.verificationId) {
                        updateLineVerificationStatus(context, chatLine);
                    }
                } else {
                    var templateInfo = getLineTemplate(context, chatLine);
                    if (templateInfo && chatLine.json){
                        var bubbleVc = new StructuredContentBubbleViewController({jsonText: chatLine.json});
                        var state = bubbleVc.renderStructureContent();
                        context.addLineElement(chatViewFragment, chatLine, templateInfo, bubbleVc);
                        if (templateInfo === context.lineTypes.AGENT || templateInfo === context.lineTypes.AGENT_PRIVATE) {
                            context.scrolledToBottom = true;
                        }
                        if(state === StructuredContentBubbleViewController.STATE.ERROR) {
                            if (context.asyncMessaging) {
                                context.updateMsgState(lpTag.AMSStatics.messageState.NACK, [chatLine.sequenceId]); // sequenceId of activeDialog
                            }
                        }
                    }
                    if (!oldChatLines) {
                        updateNewMessagesCount(context, chatLine);
                    }
                }
            }

            function renderLeCollaborationLine() {
                if (lineAlreadyExists(context, chatLine)) {
                    if (chatLine.verificationId) {
                        updateLineVerificationStatus(context, chatLine);
                    }
                } else {
                    switch (chatLine.subType) {
                        case lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM:
                            renderSecureForms();
                            break;
                    }

                    if (!oldChatLines) {
                        updateNewMessagesCount(context, chatLine);
                    }
                }
            }


            function renderSecureForms() {
                var templateInfo = getLineTemplate(context, chatLine);
                if (templateInfo) {
                    if (!chatLine.by) {
                        chatLine.by = chatLine.source; // i have rep id
                    }
                    chatLine.textType = 'plain';
                    switch (chatLine.command) {
                        case lpSecureFormsController.EVENT_TYPES.SEND:
                        case lpSecureFormsController.EVENT_TYPES.RECEIVED:
                        case lpSecureFormsController.EVENT_TYPES.VIEWED:
                        case lpSecureFormsController.EVENT_TYPES.ERROR:
                        case lpSecureFormsController.EVENT_TYPES.ABORTED:
                            context.addLineElement(chatViewFragment, chatLine, templateInfo);
                            break;

                        case lpSecureFormsController.EVENT_TYPES.SUBMIT:

                            // always add an info line for the message.
                            context.addLineElement(chatViewFragment, chatLine, context.lineTypes.INFO);

                            if (templateInfo === context.lineTypes.PARTICIPANT) {
                                // cloning the line to not override the text in the transcript.
                                var cLine = lpUtils.cloneObject(chatLine);
                                cLine.text = chatLine.args.secureFormName;
                                var vc = new SecureFormChatBubbleViewController({
                                    secureFormUniqueId: cLine.args.uniqueId,
                                    modelController: context.modelController,
                                    onDisplayResolved: context.scrollToBottomIfNeeded.bind(context),
                                    chatsRootModelPath: context.chatsRootModelPath,
                                    asyncMessaging: context.asyncMessaging
                                });

                                var lineView = context.addLineElement(chatViewFragment, cLine, templateInfo, vc);
                                // Adding the CSS Styling for the bubble.
                                context.addClass(lineView, 'secure_form');
                            }
                            break;
                    }
                }
            }
        }

        function renderChatLineByMetadada(context) {
            var lineId = chatLine.id + '_metadata';
            if(lineAlreadyExists(context, {id: lineId})) {
                return;
            }
            if (chatLine.metadata && chatLine.metadata.length) {
                chatLine.metadata.forEach(function (metadata) {
                    if (metadata.type === 'EscalationSummary') {
                        var templateInfo = context.lineTypes.ANOTHER_AGENT_PRIVATE;
                        var botEscalateParams = {
                            reason: decodeURIComponent(metadata.escalatedDuringBusinessCase || ''),
                            duration: lpTag.WebAgent.logicController.getFormatDurationTime(metadata.conversationDuration).tooltip
                        };
                        botEscalateParams.topics = _.map(metadata.businessCases, function (businessCase) {
                            return decodeURIComponent(businessCase.id);
                        });
                        var mdline = {
                            id: lineId,
                            by: chatLine.by,
                            type: 'line',
                            time: chatLine.timeL || chatLine.time,
                            dialogId: chatLine.dialogId
                        };
                        var bubbleVc = new BotEscalationBubbleViewController({textInjection: botEscalateParams});
                        context.addLineElement(chatViewFragment, mdline, templateInfo, bubbleVc);
                        context.scrolledToBottom = true;
                    }
                });
            }
        }

        function updateLineVerificationStatus(context, newLine) {
            var lineView = context.getFirstElement("#" + newLine.verificationId);
            if (lineView) {//It already exists in the DOM
                verifyLine(context, newLine, lineView);
            }
        }

        function setTextHighlightValues(context) {
            context.setEngagementUnformattedTimeInfo(context.chatId);
            context.engagmentAgentName = context.getModelParam(context.chatsRootModelPath + context.chatId + ".agentInfo.agentNickname");
            context.engagmentAgentDeleted = context.getModelParam(context.chatsRootModelPath + context.chatId + ".agentInfo.agentDeleted");
            context.supportTextHighLight = isTransferredOccurred(context, chatLines);
            context.agentFirstRowAttached = false;
            context.agentLastRowAttached = false;
            context.endSapratorNeeded = isEndTransferredSeparatorNeeded(context);
        }

        function isEndTransferredSeparatorNeeded(context) {
            for (var i = chatLines.length - 1; i >= 0; i--) {
                if (chatLines[i].controlType === 3 && chatLines[i].timeL > context.engagmentTimeObj.endTime) {
                    return true;
                }
            }
            return false;
        }

        function isTransferredOccurred(context, data) {
            var templateInfo;
            for (var i = 0; i < data.length; i++) {
                templateInfo = getLineTemplate(context, data[i]);
                if (templateInfo && templateInfo.user !== "system") {
                    if (context.engagmentTimeObj.startTime > data[i].timeL) {
                        return true;
                    }
                    break;
                }
            }

            for (var j = data.length - 1; 0 <= j; j--) {
                templateInfo = getLineTemplate(context, data[j]);
                if (templateInfo && templateInfo.user !== "system") {
                    if (context.engagmentTimeObj.endTime < data[j].timeL) {
                        return true;
                    }
                    break;
                }
            }
            return false;
        }

        function verifyLine(context, lineObject, lineView) {
            if (lineObject.verified) {
                lineView.style.opacity = 1;
            } else if (lineObject.failed) {
                context.addClass(lineView, "error");
                renderChatLineState(context, lineObject, lineView);
            }
        }

        function renderChatLineState(ctx, data, view) {

            if (data.errorData &&
                data.errorData.internalCode === 5 &&
                data.errorData.message === 'profanity-filtered') {

                var iconElement = ctx.getFirstElement('.lpview_state_icon', view);
                if (iconElement) {
                    iconElement.setAttribute('title', ctx.translate('chatLine.state.tooltip.profane') || '');
                    ctx.addClass(iconElement, 'profane');
                    ctx.addClass(view, 'line_state');
                }
            }
        }

        function lineAlreadyExists(context, line) {
            var lineId = (typeof line["@id"] !== 'undefined') ? line["@id"] : line.id;
            if (typeof lineId === 'undefined') {
                lineId = line.verificationId;
            }
            if (!context.chatLineIds[chatId]) {
                context.chatLineIds[chatId] = {};
            }
            if (typeof lineId !== 'undefined' && !context.chatLineIds[chatId][lineId] && !(context.chatLineIds[chatId][line.verificationId])) {
                context.chatLineIds[chatId][lineId] = true;
                return false;
            } else if (context.chatLineIds[chatId] && context.chatLineIds[chatId][line.verificationId] && typeof lineId !== 'undefined') {
                context.chatLineIds[chatId][lineId] = true;
            } else if (context.chatLineIds[chatId] && context.chatLineIds[chatId][lineId] && typeof line.verificationId !== 'undefined') {
                context.chatLineIds[chatId][line.verificationId] = true;
            }

            return typeof lineId !== 'undefined';
        }

        function getLineTemplate(context, newLine) {
            var lineType = getLineType(newLine), isLineSanitized, templateInfo;

            switch (lineType) {
                case 'line':
                case 'richContent':
                    templateInfo = getChatLineTemplate();
                    break;
                case 'leCollaboration':
                    templateInfo = getCollaborationLineTemplate();
                    break;
            }


            if (newLine.text !== "" || context.isImageLine(newLine) &&
                templateInfo !== context.lineTypes.PARTICIPANT &&
                lpUtils.hasHtml(newLine.text)) {
                var sanitizedRes = context.sanitizeText(newLine.text);
                newLine.text = sanitizedRes.text;
                isLineSanitized = sanitizedRes.sanitized;
            }

            // only the logged-in agent should see the censored line
            if (isLineSanitized && (templateInfo == context.lineTypes.AGENT || templateInfo == context.lineTypes.AGENT_PRIVATE)) {
                var fromUser = templateInfo.user;
                templateInfo = context.lineTypes.AGENT_CENSORED;
                templateInfo.fromUser = fromUser;
            }
            return templateInfo;

            function getChatLineTemplate() {
                switch (newLine.source) {
                    case context.lineTypes.AGENT.user:
                        if (!isOriginatedByMe(newLine)) {//An agent line coming back from the server that's not from our Agent
                            if (newLine.subType && newLine.subType === context.lineSubTypes.ONLY_TO_REP) {
                                return context.lineTypes.ANOTHER_AGENT_PRIVATE;
                            } else if (newLine.subType && newLine.subType === context.lineSubTypes.STALLER || newLine.subType === context.lineSubTypes.NON_RESPONSIVE) {
                                return context.lineTypes.ANOTHER_AGENT_AUTOMATED;
                            } else {
                                return context.lineTypes.ANOTHER_AGENT;
                            }
                        } else if (newLine.subType &&
                            (newLine.subType === context.lineSubTypes.STALLER || newLine.subType === context.lineSubTypes.NON_RESPONSIVE)) {
                            return context.lineTypes.AGENT_AUTOMATED;
                        } else if (newLine.verificationId || !context.ignoreCurrentAgentLines || context.singleton) { //Our lines on refresh or transfer
                            if (newLine.subType && newLine.subType === context.lineSubTypes.ONLY_TO_REP) {
                                return context.lineTypes.AGENT_PRIVATE;
                            } else {
                                return context.lineTypes.AGENT;
                            }
                        }
                        break;
                    case context.lineTypes.INFO.user:
                        return context.lineTypes.INFO;
                    case context.lineTypes.PARTICIPANT.user:
                        return context.lineTypes.PARTICIPANT;
                    default:
                        break;
                }

                function isOriginatedByMe(newLine) {
                    if (context.asyncMessaging) {
                        return isLoggedInAgentLine(context, newLine);
                    } else {
                        return newLine.by && newLine.by === context.agentName;
                    }
                }
            }

            function getCollaborationLineTemplate() {
                var isActiveChat = !newLine.chatId || lpTag.WebAgent.logicController.isActiveChat(newLine.chatId); //if there is not chatId in the line, it's a RT request
                var hasViewSecureFormInHistory = lpTag.WebAgent.logicController.hasSecureFormsHistoryViewFeature();

                if ((isActiveChat || hasViewSecureFormInHistory) && lpSecureFormsController) {
                    switch (newLine.source) {
                        case context.lineTypes.AGENT.user:
                            switch (newLine.subType) {
                                case lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM:
                                    switch (newLine.command) {
                                        case lpSecureFormsController.EVENT_TYPES.SEND:
                                            if (newLine.by && newLine.by !== context.agentName && !isLoggedInAgentLine(context, newLine)) {//An agent line coming back from the server that's not from our Agent
                                                return context.lineTypes.ANOTHER_AGENT;
                                            }
                                            else if (newLine.verificationId || !context.ignoreCurrentAgentLines || context.singleton) { //Our lines on refresh or transfer
                                                return context.lineTypes.AGENT;
                                            }
                                            break;
                                        case lpSecureFormsController.EVENT_TYPES.VIEWED:
                                            return context.lineTypes.INFO;
                                    }
                                    break;
                            }
                            break;
                        case context.lineTypes.PARTICIPANT.user:
                            switch (newLine.subType) {
                                case lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM:
                                    switch (newLine.command) {
                                        case lpSecureFormsController.EVENT_TYPES.SUBMIT:
                                            if (lpTag.WebAgent.secureFormsController.canViewSecureForm(newLine.args.uniqueId)) {
                                                return context.lineTypes.PARTICIPANT;
                                            } else {
                                                return context.lineTypes.INFO;
                                            }
                                            break;
                                        default:
                                            return context.lineTypes.INFO;
                                    }
                                    break;
                            }
                            break;
                    }
                }
            }
        }

        function isLoggedInAgentLine(context, newLine) {
            var isMine = false;
            var messagingUserId = context.getModelParam('agent.messagingUserId');
            if (newLine.originatorId === messagingUserId) {
                isMine = true;
            }

            return isMine;
        }

        function updateNewMessagesCount(context, newLine) {

            if (!shouldUpdateNewMessage()) {
                return;
            }

            if (!context.scrolledToBottom) {
                switch (newLine.source) {
                    case context.lineTypes.PARTICIPANT.user:
                        context.newMessages++;
                        break;
                    case context.lineTypes.AGENT.user:
                        if (newLine.by) {
                            if (newLine.by === context.agentName) {
                                // This is a line by our agent - we want to scroll down
                                if (newLine.subType === context.lineSubTypes.REGULAR || newLine.subType === context.lineSubTypes.ONLY_TO_REP ||
                                    (newLine.subType === context.lineSubTypes.SECURE_FORM && newLine.command === 'send')) {
                                    // this is a regular/private message
                                    context.scrolledToBottom = true;
                                    context.newMessages = 0;
                                }
                            } else {
                                // This is a line by another agent
                                context.newMessages++;
                            }
                        }
                        break;
                }
            } else {
                context.newMessages = 0;
            }

            function shouldUpdateNewMessage() {
                if (!context.supportNewMessagesCount ||
                    context.asyncMessaging && newLine && newLine.type !== 'line' && newLine.subType !== context.lineSubTypes.SECURE_FORM && newLine.type !== context.lineSubTypes.RICH_CONTENT ||
                    newLine.subType === context.lineSubTypes.SECURE_FORM && !(newLine.command === 'send' || newLine.command === 'submit')) {
                    return false;
                }
                return true;
            }
        }
    };

    ChatViewController.prototype.scrollToSpecificLine = function (context, cssClassName) {
        if (this.supportTextHighLight || this.asyncMessaging) {
            var that = context;
            ///waiting for the el element to be ready
            setTimeout(function () {
                var chatRow = that.getFirstElement(cssClassName);
                var chatLinesArea = that.getFirstElement(that.LPViewMap.chatLinesArea);
                if (chatLinesArea && chatRow) {
                    chatLinesArea.scrollTop = chatRow.offsetTop;
                }
            }, 100);
        }
    };
    ChatViewController.prototype.setChatByState = function (data) {
        // if we don't get data (no event fire) use the state in the model
        var state = data ? data.newValue : this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.state');
        if (state === 'transferred' || state === 'ended') {
            this.setChatInactiveCompletedState(state);
        } else if (state === 'chatting') {
            this.setChatActiveState();
        }
    };

    /**
     * This method should set the chat area into the "inactive" state, maintain scrolling,
     * show the "chat ended" bar, update the chat timestamps etc.
     * @param state
     */
    ChatViewController.prototype.setChatInactiveCompletedState = function (state) {
        var preserveScrollToBottom = this.isScrolledToBottom();
        this.removeClass(this.LPViewMap.chatState, this.chatStates.active);
        this.addClass(this.LPViewMap.chatState, this.chatStates.inactive);
        this.setInactiveCompletedHeaderTexts(state);
        this.clearTypingStateValue();
        this.updateChatEndTimeAndDuration();
        this.hideSentimentMessage();
        this.ignoreCurrentAgentLines = false;
        // Setting the "inactive" state to the chat area can change it's scrolling position,
        // therefore, we make sure that if it was scrolled to bottom prior to the state change we preserve it.
        if (state === 'ended') {
            if (this.lastQuickRepliesVC) {
                this.lastQuickRepliesVC.renderQuickRepliesAsObsolete();
            }
            if (preserveScrollToBottom) {
                this.scrollToBottom();
            }
        }
    };

    ChatViewController.prototype.setChatActiveState = function () {
        this.removeClass(this.LPViewMap.chatState, this.chatStates.inactive);
        this.addClass(this.LPViewMap.chatState, this.chatStates.active);
    };

    ChatViewController.prototype.setInactiveCompletedHeaderTexts = function (state) {
        var endTimeView = this.getFirstElement(this.LPViewMap.endTimeText);

        if (endTimeView) {
            if (this.asyncMessaging) {
                endTimeView.innerHTML = state === 'ended' ? this.translate('conversationEndTimeText') : this.translate('conversationTransferTimeText');
            } else {
                endTimeView.innerHTML = state === 'ended' ? this.translate('chatEndTimeText') : this.translate('chatTransferTimeText');
            }
        } else {
            this.logger.error('Failed to set the end time, could not find appropriate view', 'stateChanged');
        }
    };

    /**
     * This method will checks if the chat area is scrolled to bottom
     */
    ChatViewController.prototype.isScrolledToBottom = function () {
        var chatArea = this.getFirstElement(this.LPViewMap.chatLinesArea, this.view);
        return !!(chatArea && (chatArea.clientHeight + chatArea.scrollTop === chatArea.scrollHeight));
    };

    ChatViewController.prototype.clearTypingStateValue = function () {
        var visitorStateView = this.getFirstElement(this.LPViewMap.visitorState);
        if (visitorStateView) {
            this.setVisitorTypingState(visitorStateView, false);
        } else {
            this.logger.error('Failed to set the visitor state, could not find appropriate view', 'stateChanged');
        }
    };

    ChatViewController.prototype.updateChatEndTimeAndDuration = function () {
        var chatEndTimeView = this.getFirstElement(this.LPViewMap.chatEndTime);
        var chatDurationView = this.getFirstElement(this.LPViewMap.chatDuration);

        if (!this.asyncMessaging) {
            if (!chatEndTimeView) {
                this.logger.error("Failed to set the chat end time, could not find appropriate view", "updateChatEndTimeAndDuration");
            }
            if (!chatDurationView) {
                this.logger.error("Failed to set the chat duration, could not find appropriate view", "updateChatEndTimeAndDuration");
            }
        } else {
            var chat_state_view = this.getFirstElement(this.LPViewMap.chatState);
            this.addClass(chat_state_view, "messaging");
            this.addClass(chatEndTimeView, "hide_content");
        }

        var endTime = this.getModelParam(this.chatsRootModelPath + this.chatId + ".chatInfo.endTime");
        if (endTime) {
            endTime = lpUtils.createDate(endTime, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW).getTime();
            if (chatEndTimeView) {
                chatEndTimeView.innerHTML = this.formatTime(endTime);
            }
            var startTime = this.getModelParam(this.chatsRootModelPath + this.chatId + ".chatInfo.startTime");
            startTime = lpUtils.createDate(startTime, lpUtils.FORMAT_TYPES.ENGAGEMENT_WINDOW).getTime();
            if (chatDurationView) {
                chatDurationView.innerHTML = lpTag.WebAgent.logicController.getFormatDurationTime(endTime - startTime).text;
            }
        } else {
            if (chatEndTimeView) {
                chatEndTimeView.innerHTML = this.translate("notAvailable");
            }
            if (chatDurationView) {
                chatDurationView.innerHTML = this.translate("notAvailable");
            }
        }
        chatEndTimeView = null;
        chatDurationView = null;
    };

    ChatViewController.prototype.endChat = function () {
        this.modelController.endChat({
            chatId: this.chatId
        });
    };

    ChatViewController.prototype.setEngagementUnformattedTimeInfo = function (chatId) {
        this.engagmentTimeObj = {};
        if (chatId) {
            this.engagmentTimeObj.startTime = this.getModelParam(this.chatsRootModelPath + chatId + '.chatInfo.startTime');
            this.engagmentTimeObj.endTime = this.getModelParam(this.chatsRootModelPath + chatId + '.chatInfo.endTime');
        }
    };

    ChatViewController.prototype.lineInSection = function (data) {
        if (!this.engagmentTimeObj) {
            return;
        }
        return data.timeL >= this.engagmentTimeObj.startTime &&
            data.timeL <= this.engagmentTimeObj.endTime;
    };

    ChatViewController.prototype.addLineElement = function (targetView, data, templateInfo, vc) {
        if (data && data.separatorOnly) { // in case we only want to add separator without a line
            addDataSeparatorIfRequired(this, data, true);
        }
        if (!data || !templateInfo || data.text === '' && !this.isImageLine(data) || (!(data.text || vc || this.isImageLine(data)) && templateInfo !== this.lineTypes.AGENT_CENSORED)) {
            return;
        }

        addDataSeparatorIfRequired(this, data);
        var newBubble = isNewBubble(this, templateInfo, data);
        var bubbleView = getBubbleView(this, templateInfo, data);
        var opacity = "";
        addSeparatorIfRequired(this, templateInfo);

        if (this.supportTextHighLight) {
            //use to implement the text highlight in history engagement
            opacity = getOpacityIfNeeded(this);
            addTransferSeparatorIfNeeded(this);
        }

        var name = getName(this, data);
        var time = getFormattedTime(this, data);
        var bubbleLabel = getBubbleLabel(this, templateInfo, bubbleView, newBubble);
        var warning = getWarningMessage(this, templateInfo);
        var agentDeleted = data.agentDeleted ? ' ' + this.translate('agent_deleted_indication') : '';

        updateDialogsWithLinesObject(this, data);

        if (newBubble) {
            injectBubbleTexts(this, targetView, bubbleView, templateInfo.user === "system" ? data.text.toString() : "", name, time, bubbleLabel, warning, opacity, agentDeleted);
        }

        var lineView = createLineView(this, bubbleView, templateInfo, data, time);
        if (this.asyncMessaging && data.first) {
            if (this.firstRow) {
                this.scrollToClass = 'first_line_to_scroll' + data.sequenceId;
                this.firstRow = false;
            }
            this.addClass(lineView, 'first_line_to_scroll' + data.sequenceId);
        }
        if (data.text || this.isImageLine(data)) {
            renderTexts(this, templateInfo, data, lineView);
        }
        if (vc) {
            appendViewControl(this, vc, lineView);
        }
        if (data.externalFileLink) {
            appendFileLink(this, templateInfo, data, lineView);
        }
        handleQuickReplies(this, data, lineView);
        setTitleAndStyle(this, data, bubbleView, lineView);

        if (data.verificationId) {
            lineView.setAttribute("id", data.verificationId);
        }

        addDataSeparatorIfRequired(this, data, true);

        return lineView;

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////// help methods ////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function updateDialogsWithLinesObject(context, data) {
            if (context.asyncMessaging && data.dialogId) {
                if (!context.dialogsWithLines) {
                    context.dialogsWithLines = {};
                }
                context.dialogsWithLines[data.dialogId] = true;
            }
        }

        function handleQuickReplies(context, data, lineView) {
            var element, error, quickRepliesErrorTemplate;
            var quickRepliesJson = data.quickReplies;

            // this method is reached only when there is a ***new*** line
            // if there is a reference to QR line and the current line is NOT auto messages
            // then mark the QR line as obsolete
            if (context.lastQuickRepliesVC && data.source !== 'system') {
                context.lastQuickRepliesVC.renderQuickRepliesAsObsolete();
                context.lastQuickRepliesVC = void 0;
            }

            if (quickRepliesJson) {

                element = context.getFirstElement('.chat_single_line_container', lineView);
                if (element) {
                    try {
                        if (_.isString(quickRepliesJson)) {
                            quickRepliesJson = JSON.parse(quickRepliesJson);
                        }
                        SchemaValidator.validate(SchemaValidator.KEYS.QUICK_REPLIES, quickRepliesJson);
                    } catch (e) {
                        error = e;
                    }

                    if (error) {
                        quickRepliesErrorTemplate = require('web-agent-templates/LP_quick_replies_cannot_render.html');
                        context.createView({template: quickRepliesErrorTemplate, target: element});
                    } else {
                        context.lastQuickRepliesVC = new QuickRepliesBubbleViewController({
                            quickReplies: quickRepliesJson,
                            convId: context.chatId,
                            dialogId: data.dialogId,
                            data: data,
                            modelController: context.modelController,
                            chatsRootModelPath: context.chatsRootModelPath,
                            isHistory: context.isHistory
                        });
                        context.addViewController({viewController: context.lastQuickRepliesVC, target: element});
                    }
                }
            }
        }

        function appendViewControl(context, viewControl) {
            if (templateInfo.textPlaceholder) {
                var lineText = context.getFirstElement(templateInfo.textPlaceholder, lineView);
                if(!lineText && context.alternateTextPlaceholder) { //in case where createLineView() has decided to return different template than templateInfo
                    lineText = context.getFirstElement(context.alternateTextPlaceholder, lineView);
                }
                if (lineText) {
                    context.addViewController({viewController: viewControl, target: lineText});
                }
            }
        }

        /**
         * Append an file link to the chat line
         * @param context
         * @param templateInfo
         * @param fileData
         * @param lineView
         */
        function appendFileLink(context, templateInfo, fileData, lineView) {
            if (templateInfo.textPlaceholder) {
                var lineText = context.getFirstElement(templateInfo.textPlaceholder, lineView);
                if (lineText) {
                    var fileTemplate, injectionTexts;
                    switch (fileData.fileType) {
                        case lpAMSController.FILE_TYPES.IMG:
                            fileTemplate = require("web-agent-templates/LP_chat_bubble_single_line_image.html");
                            // fileTemplate = lpUtils.loadResource("web-agent-templates/LP_chat_bubble_single_line_image.html");
                            injectionTexts = {
                                imageSrc: fileData.externalFileLink,
                                imageCaption: fileData.caption
                            };
                            break;
                        case lpAMSController.FILE_TYPES.OTHER:
                            fileTemplate = require("web-agent-templates/LP_chat_bubble_single_line_file.html");
                            // fileTemplate = lpUtils.loadResource("web-agent-templates/LP_chat_bubble_single_line_file.html");
                            injectionTexts = {
                                fileSrc: fileData.externalFileLink,
                                fileCaption: fileData.caption
                            };
                            break;
                        default:
                            return;
                    }
                    lineText.innerHTML = context.injectTextDefaults(fileTemplate, injectionTexts);
                }
            }
        }

        function addTransferSeparatorIfNeeded(context) {
            if (context.lineInSection(data)) {
                //in this section of the 'if' we reach only if the data(line) is in the specific  agent engagement section
                //if the agent first line is not attached  and we in the agent engagement section we need to  add separator
                if (!context.agentFirstRowAttached) {
                    addStartTransferSeparator(context);
                }
            } else {
                //check if the agent first row is already attached to the engagement window
                //agentFirstRowAttached === true only after the first line of the agent engagement is attached to the engagement window
                //agentLastRowAttached === true only after the last line of the agent engagement is attached to the engagement window
                if (context.agentFirstRowAttached && !context.agentLastRowAttached && context.endSapratorNeeded) {
                    addEndTransferSeparator(context);
                }
            }
        }

        function getOpacityIfNeeded(context) {
            if (context.lineInSection(data)) {
                return "";
            } else {
                return "opacity";
            }
        }

        function setTitleAndStyle(context, data, bubbleView, lineView) {
            if (!data.text) {
                return;
            }
            var textForTitle = context.formatAsText(data.text, true);//This is for the title JAWS support
            lineView.setAttribute("title", (data.by || "") + ": " + textForTitle);//For JAWS compliance we need titles
            lineView.setAttribute("tooltip-hide", "");
            if (data.style) {
                context.addInlineStyle(data.style, bubbleView);
            }
        }

        function renderTexts(context, templateInfo, data, lineView) {
            // This is made to resolve the problem on error system messages to render as is without html removal..
            if (templateInfo.textPlaceholder) {
                var lineText = context.getFirstElement(templateInfo.textPlaceholder, lineView);
                if (lineText) {
                    if (context.asyncMessaging || templateInfo.user === context.lineTypes.PARTICIPANT.user) {
                        if (lineText.innerText !== undefined) {
                            var temp = lpUtils.escapeHTML(data.text).replace(/(\r\n|\n|\r)/gm, '<br/>');
                            lineText.innerHTML = lpTag.WebAgent.smileyEmojisController.replaceEmojiCodesByImages(context, context.asyncMessaging, temp);

                        } else {
                            lineText.textContent = data.text;
                        }
                    } else {
                        lineText.innerHTML = data.text;
                    }
                }
            }

        }

        function addStartTransferSeparator(context) {
            var agentData = {
                agentName: context.engagmentAgentName,
                agentDeleted: context.engagmentAgentDeleted ? ' ' + context.translate('agent_deleted_indication') : ''
            };
            if (!context.agentFirstRowAttached) {
                context.createView({
                    templateFile: "LP_chat_bubble_transfer_border_start.html",
                    target: targetView,
                    textInjection: agentData
                });
                context.agentFirstRowAttached = true;
            }
        }

        function addEndTransferSeparator(context) {
            if (!context.agentLastRowAttached) {
                context.createView({
                    templateFile: "LP_chat_bubble_transfer_border_end.html",
                    target: targetView
                });
                context.agentLastRowAttached = true;
            }
        }

        function createLineView(context, bubbleView, templateInfo, data, time) {
            var lineTexts = {
                time: newBubble ? "" : time.hoursMinutes,
                timeWithSeconds: newBubble ? "" : time.hoursMinutesSeconds
            };

            if (lpTag.WebAgent.logicController.hasIdnvFeature() && templateInfo.user === context.lineTypes.PARTICIPANT.user) {
                data.text = WebAgentUtils.removeIdnvSpansFromChatLine(data.text);
            }

            if (context.asyncMessaging || templateInfo.user !== context.lineTypes.PARTICIPANT.user) {
                var tempLineTextsText = typeof data.text !== "undefined" ? data.text : '';
                if (context.asyncMessaging) {
                    tempLineTextsText = lpUtils.escapeHTML(tempLineTextsText);
                }
                tempLineTextsText = tempLineTextsText.toString().replace(/(\r\n|\n|\r)/gm, '<br/>');
                lineTexts.text = lpTag.WebAgent.smileyEmojisController.replaceEmojiCodesByImages(context, context.asyncMessaging, tempLineTextsText);
            }

            var lineView;
            var linesAreaInBubbleView = context.getFirstElement(context.LPViewMap.linesAreaInBubble, bubbleView);
            if (linesAreaInBubbleView) {
                var templateFile = getTemplateFile();
                lineView = context.createView({
                    templateFile: templateFile,
                    textInjection: lineTexts,
                    target: linesAreaInBubbleView
                });
                context.alternateTextPlaceholder = '.lpview_single_line_bubble_text';
            } else {
                lineView = bubbleView;
            }

            if (context.asyncMessaging) {
                context.chatLineStates.push(new ChatLineStateViewController({
                    lineView: lineView,
                    convId: context.chatId,
                    chatsRootModelPath: context.chatsRootModelPath,
                    modelController: context.modelController,
                    data: data
                }));
                if (data && data.event && data.event.contentType === "hosted/file" || data.contentType === "hosted/file") {
                    if (data.isAudio) {
                        new ChatLineAudioViewController({
                            lineView: lineView,
                            convId: context.chatId,
                            modelController: context.modelController,
                            data: data,
                            isFeatureEnabled: lpTag.WebAgent.logicController.isAudioSharingEnabled()
                        });
                    } else {
                        new ChatLineImageViewController({
                            lineView: lineView,
                            convId: context.chatId,
                            modelController: context.modelController,
                            data: data,
                            isFeatureEnabled: lpTag.WebAgent.logicController.isFileSharingEnabled() || lpTag.WebAgent.logicController.isAgentFileSharingEnabled()
                        });
                        if (data.verificationId) {
                            context.viewEventsHandler.bindEvent({
                                appName: data.verificationId,
                                UIEvent: context.eventType.SHOW_FILE_UPLOAD_ERROR,
                                callback: context.updateUploadState
                            });
                        }
                    }
                }
            }

            // if we have text, we will try to test the direction and attach the direction to the style.
            if(data && data.text){
                var textDirection = LocalizationHelper.detectTextDirection(data.text);
                if(textDirection){
                    // TODO: Check Cross browser support.
                    lineView.dir = textDirection.value;
                }
            }

            return lineView;

            function getTemplateFile() {
                return (getLineType(data) === "richContent") ? "LP_chat_bubble_single_line_structure_content.html" : "LP_chat_bubble_single_line.html";
            }
        }

        function injectBubbleTexts(context, targetView, bubbleView, text, name, time, bubbleLabel, warningMessage, opacity, agentDeleted) {
            var bubbleTexts = {
                name: name.toString(),
                time: time.hoursMinutes,
                timeWithSeconds: time.hoursMinutesSeconds,
                text: text,
                label: bubbleLabel,
                warning: warningMessage,
                opacity: opacity,
                agentDeleted: agentDeleted
            };
            context.injectTextDefaults(bubbleView, bubbleTexts);
            context.addView({targetView: targetView, viewToAdd: bubbleView});
        }

        function getBubbleLabel(context, templateInfo, bubbleView, newBubble) {
            var bubbleLabel = "";
            if (newBubble) {
                if (templateInfo.user === context.lineTypes.ANOTHER_AGENT_PRIVATE.user || templateInfo.user === context.lineTypes.AGENT_PRIVATE.user) {
                    bubbleLabel = context.translate("chatPrivateLine");
                    var agentBubble = context.getFirstElement(templateInfo.bubble, bubbleView);
                    context.addClass(agentBubble, context.LPClassesMap.private);
                } else if (templateInfo.user == context.lineTypes.AGENT_AUTOMATED.user || templateInfo.user == context.lineTypes.ANOTHER_AGENT_AUTOMATED.user) {
                    bubbleLabel = context.translate("chatAutomatedLine");
                }
            }
            return bubbleLabel;
        }

        function getWarningMessage(context, templateInfo) {
            var warningMessage;
            if (templateInfo.user === context.lineTypes.AGENT_CENSORED.user) {
                switch (templateInfo.fromUser) {
                    case context.lineTypes.AGENT.user:
                        warningMessage = context.translate("contentSanitized");
                        break;
                    case context.lineTypes.AGENT_PRIVATE.user:
                        warningMessage = context.translate("contentSanitizedPrivateMessage");
                        break;
                }
            }

            return warningMessage;
        }

        function getName(context, data) {
            var newName = data.by = lpTag.WebAgent.logicController.getVisitorNameFromTranscript(data.by);
            if (newName == context.previousName) {
                newName = '';
            } else {
                context.previousName = newName;
            }

            return newName;
        }

        function getFormattedTime(context, data) {
            var formattedTime;
            var lineTime = data.timeL || data.time;
            var hoursMinutesFormattedTime = context.formatTime(lineTime);
            // return empty values for a time within the same minute - we should render it as empty
            if (hoursMinutesFormattedTime == context.previousTime) {
                formattedTime = {
                    hoursMinutes: '',
                    hoursMinutesSeconds: ''
                };
            } else {
                formattedTime = {
                    hoursMinutes: hoursMinutesFormattedTime,
                    hoursMinutesSeconds: context.formatTime(lineTime, true)
                };
                context.previousTime = hoursMinutesFormattedTime;
            }
            return formattedTime;
        }

        function addDataSeparatorIfRequired(context, data, endSeparator) {
            if (!data || !data.time) {
                return;
            }
            var currentDate = new Date(data.timeL || data.time).setHours(0, 0, 0, 0);
            var dateFormated = lpUtils.formatDateAsString(currentDate, true);
            var dialog = lpTag.WebAgent.logicController.getDialogOfConversation(data.conversationId, data.dialogId, context.chatsRootModelPath);
            var dialogType = dialog && dialog.dialogType;
            if (endSeparator) { // end dialog separator
                if (data.lastLineOfDialog && checkDialogSeparationNeeded(dialogType, context.separatorTypes.dialogEnd)) {
                    addDialogSeparator(context, dateFormated, dialogType, context.separatorTypes.dialogEnd);
                }
            }
            else {
                if ((data.firstLineOfDialog || context.previousDialogId !== data.dialogId) && checkDialogSeparationNeeded(dialogType, context.separatorTypes.dialogStart)) { // start dialog separator
                    addDialogSeparator(context, dateFormated, dialogType, context.separatorTypes.dialogStart);
                }
                else if (!context.previousDate) {
                    createSeparator(context, {type: context.separatorTypes.date, textInjection: {date: dateFormated}});
                }
                else if (context.previousDate != currentDate) { // not first chat line
                    createSeparator(context, {type: context.separatorTypes.date, textInjection: {date: dateFormated}});
                    context.previousBubbleSource = null;
                }
            }
            context.previousDate = currentDate;
            context.previousDialogId = data.dialogId;
        }

        function addDialogSeparator(context, dateFormated, dialogType, dialogSeparatorType) {
            createSeparator(context, {
                type: dialogSeparatorType,
                textInjection: {date: dateFormated, text: getDialogSeparationText(context, dialogType, dialogSeparatorType)}
            });
            context.previousBubbleSource = null;
        }

        /**
         * Check dialog separator element is needed for the dialogId and type
         * @param dialogType
         * @param separationType - dialogStart/dialogEnd
         */
        function checkDialogSeparationNeeded(dialogType, separationType) { //might also check on the separation type
            var isNeeded = false;
            switch (dialogType) {
                case lpTag.WebAgent.logicController.dialogTypes.POST_SURVEY:
                    isNeeded = privilegesController.hasViewMessagingSurveysPrivilege();
                    break;
            }
            return isNeeded;
        }

        function getDialogSeparationText(context, dialogType, separationType) {
            var text = '';
            switch (dialogType) {
                case lpTag.WebAgent.logicController.dialogTypes.POST_SURVEY:
                    text = context.translate('post_survey' + '_' + separationType);
                    break;
            }
            return text;
        }

        /**
         * Add separator element to the chat
         * @param context
         * @param typeInfo : {type : context.separatorTypes.XXX, textInjection : {}}
         */
        function createSeparator(context, typeInfo) {
            switch (typeInfo.type) {
                case context.separatorTypes.simple:
                    context.createView({
                        templateFile: "LP_chat_bubble_border.html",
                        target: targetView
                    });
                    break;
                case context.separatorTypes.date:
                    context.createView({
                        templateFile: "LP_chat_separator.html",
                        target: targetView,
                        textInjection: typeInfo.textInjection
                    });
                    break;
                case context.separatorTypes.dialogStart:
                case context.separatorTypes.dialogEnd:
                    context.createView({
                        templateFile: "LP_chat_dialog_separator.html",
                        target: targetView,
                        textInjection: typeInfo.textInjection
                    });
                    break;
            }
        }

        function addSeparatorIfRequired(context, templateInfo) {
            // add separator if needed
            var previousBubbleRequireSeparator = context.previousBubbleSource === context.lineTypes.AGENT.user ||
                context.previousBubbleSource === context.lineTypes.AGENT_AUTOMATED.user ||
                context.previousBubbleSource === context.lineTypes.INFO.user;
            var currentTemplateNeedsSeparator = templateInfo.user === context.lineTypes.AGENT.user ||
                templateInfo.user === context.lineTypes.AGENT_AUTOMATED.user ||
                templateInfo.user === context.lineTypes.INFO.user;

            if (previousBubbleRequireSeparator && currentTemplateNeedsSeparator && context.previousBubbleSource !== templateInfo.user) {
                createSeparator(context, {type: context.separatorTypes.simple});
            }
        }

        function isNewBubble(context, templateInfo, data) {
            var newBubble = false;
            if (!context.previousBubbleSource) {
                newBubble = true;
            } else {
                var newBubbleSource = getBubbleSource(context, templateInfo, data);
                if (context.previousBubbleSource != newBubbleSource) {
                    newBubble = true;
                } else if (templateInfo.user === 'system') {
                    newBubble = true;
                }
            }
            if (data && data.event && data.event.contentType === "hosted/file" ||
                data.contentType === "hosted/file" ||
                context.previousBubbleType === "hosted/file" ||
                context.previousBubbleType === "forms/secure-submission") {
                newBubble = true;
            }
            return newBubble;
        }

        function getBubbleView(context, templateInfo, data) {
            var bubbleView;

            if (isNewBubble(context, templateInfo, data)) {
                //TODO: The "useOriginalTemplate" is only used by the Chat View Controller.
                //In the future we should always create the view when we have what we need to
                //Translate the template.
                bubbleView = context.createView({
                    templateFile: templateInfo.templateFile,
                    doNotAddChild: true,
                    useOriginalTemplate: true,
                    target: targetView
                });
                context.previousTime = '';
                context.previousName = '';
                context.previousBubble = bubbleView;
            } else {
                bubbleView = context.previousBubble;
            }
            context.previousBubbleSource = getBubbleSource(context, templateInfo, data);
            if(data.event){
                context.previousBubbleType = data.contentType ||data.event.contentType;
            }

            return bubbleView;
        }

        function getBubbleSource(context, templateInfo, data) {
            var source = templateInfo.user + '_' + data.by;
            if (templateInfo === context.lineTypes.AGENT_CENSORED) {
                source += '_' + templateInfo.fromUser;
            }
            return source;
        }
    };

    ChatViewController.prototype.dispose = function() {
        this.disposeChatLineStates();
        ViewController.prototype.dispose.call(this);
    };

    ChatViewController.prototype.disposeChatLineStates = function () {
        for(var i = 0 ; i < this.chatLineStates.length; i++){
            this.chatLineStates[i].dispose();
        }
        this.chatLineStates = [];
    };

    ChatViewController.prototype.saveScrollingPosition = function (e) {
        this.scrollPosition = e.sourceElement.scrollTop;
        this.checkIfScrolledToBottom();
        this.visitorNewMessagesState();
    };

    ChatViewController.prototype.resumeScrollingPosition = function () {
        if (this.scrollPosition) {
            var chatArea = this.getFirstElement(this.LPViewMap.chatLinesArea, this.view);
            if (chatArea) {
                chatArea.scrollTop = this.scrollPosition;
                chatArea = null;
            }
        }
    };

    ChatViewController.prototype.scrollToBottom = function () {
        if (!this.supprtScrollToBottom) {
            return;
        }
        var that = this;
        setTimeout(function () { // timeout for IE rendering
            var chatArea = that.getFirstElement(that.LPViewMap.chatLinesArea, that.view);
            if (chatArea) {
                chatArea.scrollTop = chatArea.scrollHeight;
                that.scrolledToBottom = true;
                that.visitorNewMessagesState();
            } else {
                that.logger.error("Failed to get the chat area for scrolling", "scrollToBottom");
            }
            chatArea = null;
        }, 0);
    };

    ChatViewController.prototype.addInlineStyle = function (style, element) {
        if (typeof style === 'object') {
            element.style = element.style || {};
            for (var key in style) {
                if (style.hasOwnProperty(key)) {
                    element.style[key] = style[key];
                }
            }
        }
    };

    ChatViewController.prototype.updateAgentName = function (data) {
        if (data && data.newValue) {
            this.agentName = data.newValue;
        }
    };
    /*
     ChatViewController.prototype.updateChatLineId = function (line) {
     var lineUpdated = true;
     var lineId = (typeof line["@id"] !== 'undefined') ? line["@id"] : line.id;

     if (typeof lineId !== 'undefined' && !this.chatLineIds[lineId]) {
     this.chatLineIds[lineId] = true;
     } else {
     lineUpdated = false;
     }

     return lineUpdated;
     };
     */
    ChatViewController.prototype.checkIfScrolledToBottom = function () {
        var chatLinesView = this.getFirstElement(this.LPViewMap.chatLinesArea);
        var chatlinesViewHeight = this.getComputedStyle(chatLinesView, "height", 10);
        this.scrolledToBottom = chatLinesView.scrollTop + chatlinesViewHeight === chatLinesView.scrollHeight;
    };

    ChatViewController.prototype.scrollToBottomIfNeeded = function () {
        // this is done to make sure the new content will be scrolled down when needed
        if (this.scrolledToBottom) {
            if (this.singleton || this.isFocused) {
                this.scrollToBottom();
            } else {
                this.scrollToBottomWhenFocused = true;
            }
        }
    };

    ChatViewController.prototype.modifyHeight = function (heightDiff) {
        if (heightDiff) {
            var typingStateView = this.getFirstElement(this.LPViewMap.visitorTypingState);
            var chatLinesView = this.getFirstElement(this.LPViewMap.chatLinesArea);
            var typingStateBottom = this.getComputedStyle(typingStateView, "bottom", 10);
            var chatLinesBottom = this.getComputedStyle(chatLinesView, "bottom", 10);
            this.checkIfScrolledToBottom();
            typingStateView.style.bottom = typingStateBottom + heightDiff + "px";
            chatLinesView.style.bottom = chatLinesBottom + heightDiff + "px";
            this.scrollToBottomIfNeeded();
        }
    };

    ChatViewController.prototype.hideSentimentMessage = function () {
        this.lpHide(this.LPViewMap.sentimentMessage);
        this.sentimentMessageVisible = false;
    };
    ChatViewController.prototype.showSentimentMessage = function () {
        this.lpShow(this.LPViewMap.sentimentMessage);
        this.sentimentMessageVisible = true;
    };

    ChatViewController.prototype.updateEngagementSentiment = function (data) {
        if (typeof data.newValue !== "undefined") {
            var sentimentTag = lpTag.WebAgent.logicController.getSentimentTag(data.newValue);
            var chatState = this.getModelParam(this.chatsRootModelPath + this.chatId + '.chatInfo.state');
            if (sentimentTag === lpTag.WebAgent.logicController.sentimentMap.negative && chatState !== "ended") {
                this.showSentimentMessage();
            } else if (this.sentimentMessageVisible) {
                this.hideSentimentMessage();
            }
        }
    };

    function getLineType(chatLine) {
        if (chatLine.textType === 'rich-content') {
            return 'richContent';
        }
        return (chatLine && ((chatLine.type || chatLine['@type']) || 'line'));
    }

    ChatViewController.prototype.isImageLine = function (line) {
        return line.isImage || line.contentType === "hosted/file";
    };

    return ChatViewController;

});
